"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _TableResizer = require("../TableResizer");
var _Table = require("../../../components/Table/Table");
var _createUseStyles = _interopRequireDefault(require("../../../themes/createUseStyles"));
var _pickAndRemoveFromObject = _interopRequireDefault(require("../../../utils/pickAndRemoveFromObject"));
var _sortTable = require("../../../utils/sortTable");
var _initVars = _interopRequireDefault(require("../../../utils/vars/initVars"));
var _excluded = ["children", "cellPadding", "sortBy", "className"];
/**
 * @copyright
 * Copyright (c) 2023 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var common = ["width", "minWidth", "maxWidth"];
var vars = (0, _initVars.default)({
  applied: common,
  variables: [{
    key: "cellPadding",
    defaultUnit: "px"
  }]
});
var TableHeader = function TableHeader(_ref) {
  var children = _ref.children,
    cellPadding = _ref.cellPadding,
    sortBy = _ref.sortBy,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var context = (0, _react.useContext)(_Table.TableContext);
  var headerClasses = useStyles(_objectSpread({
    cellPadding: cellPadding
  }, (0, _pickAndRemoveFromObject.default)(props, common)));
  var stickyHeader = context.stickyHeader,
    onHeaderClick = context.onHeaderClick,
    sortedColumn = context.sortedColumn,
    sortDirection = context.sortDirection,
    resizerId = context.resizerId;
  var resizer = resizerId ? _defineProperty({}, _TableResizer.RESIZER_ATTRIBUTE_ID, resizerId) : {};
  return /*#__PURE__*/_react.default.createElement("th", _extends({
    className: (0, _classnames.default)(headerClasses.root, headerClasses.variables, _defineProperty(_defineProperty(_defineProperty({}, headerClasses.sortableHeader, sortBy), headerClasses.stickyHeader, stickyHeader), className, className)),
    onClick: function onClick() {
      return onHeaderClick && sortBy ? onHeaderClick(sortBy) : {};
    }
  }, props, resizer), /*#__PURE__*/_react.default.createElement("div", {
    className: headerClasses.thContainer
  }, children, sortBy && /*#__PURE__*/_react.default.createElement("div", {
    className: headerClasses.sortIndicatorContainer
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(headerClasses.sortIndicator, sortBy === sortedColumn && sortDirection === _sortTable.SortDirection.DESCEND && headerClasses.activeSortIndicator)
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(headerClasses.sortIndicator, headerClasses.ascendingSortIndicator, sortBy === sortedColumn && sortDirection === _sortTable.SortDirection.ASCEND && headerClasses.activeSortIndicator)
  }))));
};
var styles = function styles(theme) {
  return {
    variables: vars.styles,
    root: {
      boxSizing: "border-box",
      borderWidth: 1,
      borderColor: theme.colors.baseContrast040,
      color: theme.colors.baseContrast085,
      background: theme.colors.baseContrast030,
      padding: vars.get("cellPadding", _Table.vars.get("cellPadding", "".concat(theme.spacing.base, "px ").concat(theme.spacing.base * 2, "px"))),
      whiteSpace: function whiteSpace(props) {
        return props.tableLayout === "auto" ? "nowrap" : undefined;
      }
    },
    thContainer: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center"
    },
    sortableHeader: {
      cursor: "pointer"
    },
    stickyHeader: {
      zIndex: 3,
      position: "sticky",
      top: -2
    },
    sortIndicatorContainer: {
      display: "flex",
      flexDirection: "column"
    },
    sortIndicator: {
      boxSizing: "border-box",
      borderColor: "transparent",
      borderStyle: "solid",
      margin: [1, 4],
      borderWidth: 4,
      // increase to make sort arrows wider
      borderTopWidth: 0,
      borderBottomWidth: 6,
      // increase to make sort arrows taller
      borderBottomColor: theme.colors.baseContrast060
    },
    ascendingSortIndicator: {
      transform: "rotate(180deg)"
    },
    activeSortIndicator: {
      borderBottomColor: theme.colors.baseContrast100
    }
  };
};
var useStyles = (0, _createUseStyles.default)(styles, {
  name: "TableHeader"
});
TableHeader.displayName = "TableHeader";
var _default = exports.default = TableHeader;